export default __webpack_public_path__ + "static/media/diamond-color-4@3x.99939448.png";